import { getMetricFromRoofLevels as o } from "../index7.js";
import { getLevelGrossFacadeArea as r } from "../level-metrics/index22.js";
const s = (e) => o(e, r);
export {
  s as getRoofGrossFacadeArea
};
//# sourceMappingURL=index50.js.map
